import { render, staticRenderFns } from "./ErtigaBoostergreen.vue?vue&type=template&id=3ef0749e&"
import script from "./ErtigaBoostergreen.vue?vue&type=script&lang=ts&"
export * from "./ErtigaBoostergreen.vue?vue&type=script&lang=ts&"
import style0 from "./ErtigaBoostergreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports